export default __webpack_public_path__ + "static/media/5-2.aebab6a2.png";